import SendEventAPI from "../../api/send-event.api";

let eventApiCallCount = 0;
let eventApiCallDelay = 10; // in sec
export function pushTrackingToKenisis() {
  const timer = setInterval(() => {
    eventApiCallCount += 1;

    SendEventAPI.sendEventWithPayload(window.trackingDataLayer);

    window.trackingDataLayer = [];
    if (eventApiCallCount % 3 === 0 && eventApiCallCount < 7) {
      clearInterval(timer);
      eventApiCallDelay += 10;
      pushTrackingToKenisis();
    }
  }, 1000 * eventApiCallDelay);
    // send events in batch (1,2, 3 - every 10 seconds; 4, 5, 6 - every 20 seconds; others - 30 seconds)
}
